import { RenderContainer } from "../RenderContainer";
import React from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import { useField } from "formik";

const TEXT_LIMIT = 2000;

const CustomTextArea: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
}) => {
  const [{ value }] = useField(field.name);
  return (
    <RenderContainer
      customFieldName={customField.name}
      orderNumber={customField.orderNumber}
    >
      <React.Fragment>
        {handleOnChange && (
          <div className="CustomTextArea">
            {value[index].value &&
              typeof value[index].value === "string" &&
              !readOnly && (
                <div className="Limit">
                  Characters remaining:{" "}
                  {`${TEXT_LIMIT - value[index].value.length}`}
                </div>
              )}
            {!value[index].value && !readOnly && (
              <div className="Limit">Maxium characters: {`${TEXT_LIMIT}`}</div>
            )}

            <textarea
              className={`TextArea${readOnly ? " ViewOnly" : ""} ${
                classWrapper ? classWrapper : ""
              } `}
              value={
                readOnly
                  ? value[index].value
                    ? (value[index].value as string)
                    : "-"
                  : (value[index].value as string)
              }
              readOnly={readOnly}
              style={{ resize: "none" }}
              onChange={e => {
                handleOnChange(e, index);
              }}
              maxLength={TEXT_LIMIT}
            />
          </div>
        )}
      </React.Fragment>
    </RenderContainer>
  );
};

export const customTextArea: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomTextArea
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
